export const activeOrdersArray = [
  {
    bidActiveDuration: '10 min',
    bidAmount: '10',
    bidType: 'Single Order',
    contact: '364-123-6586',
    estimatedTime: '20 min',
    location: '1210 W Lexington St',
    orderId: '578383',
    sendToFavorites: true,
    status: 'bid-accepted',
    lat:41.8696,
    long:-87.6496,
  },
  {
    bidActiveDuration: '10 min',
    bidAmount: '10',
    bidType: 'Single Order',
    contact: '273-372-3263',
    estimatedTime: '10 min',
    location: '712 W Abbey St',
    orderId: '543341',
    sendToFavorites: false,
    status: 'in-transit',
    lat:41.8746,
    long:-87.6690,
  },
  {
    bidActiveDuration: '20 min',
    bidAmount: '18',
    bidType: 'Single Order',
    contact: '',
    estimatedTime: 'Bid unaccepted',
    location: '424 S Northway St',
    orderId: '993642',
    sendToFavorites: true,
    status: 'bid-unaccepted',
    lat:41.8696,
    long:-87.6496,
  },
  {
    bidActiveDuration: '10 min',
    bidAmount: '10',
    bidType: 'Single Order',
    contact: '232-645-1123',
    estimatedTime: '17 min',
    location: '343 W Taylor St',
    orderId: '623562',
    sendToFavorites: false,
    status: 'bid-accepted',
    lat:41.8746,
    long:-87.6690,
  },
  {
    bidActiveDuration: '20 min',
    bidAmount: '10',
    bidType: 'Single Order',
    contact: '121-545-6575',
    estimatedTime: '9 min',
    location: '1710 N David St',
    orderId: '938463',
    sendToFavorites: true,
    status: 'in-transit',
    lat:41.8696,
    long:-87.6496,
  },
  {
    bidActiveDuration: '30 min',
    bidAmount: '75',
    bidType: 'Hire Out',
    contact: '',
    estimatedTime: 'Bid unaccepted',
    location: '765 N Loops St',
    orderId: '891990',
    sendToFavorites: true,
    status: 'bid-unaccepted',
    lat:41.8746,
    long:-87.6690,
  },
  {
    bidActiveDuration: '30 min',
    bidAmount: '50',
    bidType: 'Hire Out',
    contact: '',
    estimatedTime: 'Bid unaccepted',
    location: '727 S Morgan St',
    orderId: '756376',
    sendToFavorites: true,
    status: 'bid-unaccepted',
    lat:41.8696,
    long:-87.6496,
  },
  {
    bidActiveDuration: '15 min',
    bidAmount: '15',
    bidType: 'Single Order',
    contact: '',
    estimatedTime: 'Bid unaccepted',
    location: '1210 S Wells St',
    orderId: '293403',
    sendToFavorites: false,
    status: 'bid-unaccepted',
    lat:41.8746,
    long:-87.6690,
  },
  {
    bidActiveDuration: '10 min',
    bidAmount: '10',
    bidType: 'Single Order',
    contact: '',
    estimatedTime: 'Bid unaccepted',
    location: '1210 W Lexington St',
    orderId: '543087',
    sendToFavorites: true,
    status: 'bid-unaccepted',
    lat:41.8696,
    long:-87.6496,
  },
];

export const pastOrders = [
  {
    orderId: '123456',
    amount: '15$',
    bidType: 'Single Order',
    address: '1210 W Lexingtion Street Apt 3F',
    city: 'Chicago',
    drivers: 'James Cameron',
  },
  {
    orderId: '345678',
    amount: '10$',
    bidType: 'Hire Out',
    address: '712 S Aberdeen St Apt 3R',
    city: 'Chicago',
    drivers: 'Jimmy Neutron',
  },
  {
    orderId: '789101',
    amount: '20$',
    bidType: 'Single Order',
    address: '1218 W Flournoy St Apt 1F',
    city: 'Chicago',
    drivers: 'Jack Dawson',
  },
  {
    orderId: '565433',
    amount: '30$',
    bidType: 'Single Order',
    address: '821 S Miller St',
    city: 'Chicago',
    drivers: 'Jamie Fox',
  },
  {
    orderId: '123799',
    amount: '7$',
    bidType: 'Hire Out',
    address: '1148 W Washburne Ave',
    city: 'Chicago',
    drivers: 'Johnny Sins',
  },
];

export const month = [
  { expenses: 1234, month: 'April', delta: 30 },
  { expenses: 3356, month: 'March', delta: 43 },
  { expenses: 1122, month: 'February', delta: 13 },
  { expenses: 1233, month: 'January', delta: 17 },
  { expenses: 1111, month: 'December', delta: 27 },
  { expenses: 2222, month: 'November', delta: 31 },
  { expenses: 1112, month: 'October', delta: 57 },
  { expenses: 1134, month: 'September', delta: 23 },
  { expenses: 4567, month: 'August', delta: 52 },
];

export const driversarray = [
  {
    name: 'James',
    favorite: false,
    yourOrders: 16,
    totalOrders: 600,
    rating: 4.1,
    reviews: 100,
  },
  {
    name: 'Jimmy',
    favorite: true,
    yourOrders: 26,
    totalOrders: 125,
    rating: 4.2,
    reviews: 120,
  },
  {
    name: 'Jack',
    favorite: true,
    yourOrders: 36,
    totalOrders: 150,
    rating: 4.3,
    reviews: 140,
  },
  {
    name: 'Jamie',
    favorite: false,
    yourOrders: 46,
    totalOrders: 175,
    rating: 4.4,
    reviews: 160,
  },
  {
    name: 'Johnny',
    favorite: false,
    yourOrders: 56,
    totalOrders: 200,
    rating: 4.5,
    reviews: 180,
  },
  {
    name: 'Jacob',
    favorite: true,
    yourOrders: 66,
    totalOrders: 225,
    rating: 4.1,
    reviews: 200,
  },
  {
    name: 'Jessica',
    favorite: false,
    yourOrders: 16,
    totalOrders: 26,
    rating: 3.5,
    reviews: 10,
  },
];
